import * as Types from '@findy-code/yuffie/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchJobDescriptionDetailV2CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchJobDescriptionDetailV2CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: number, talentStatus: Types.TalentStatus, profile?: { __typename?: 'UserProfile', age?: number | null, careerMotivation: number, companyName?: string | null, numericAnnualIncome: number, vision?: string | null, latestDevelopmentResults?: string | null, desiredAnnualIncome: { __typename?: 'UserIncome', id: number }, desiredCareerType: { __typename?: 'Career', id: number }, prefecture: { __typename?: 'Prefecture', id: number } } | null, jobs: Array<{ __typename?: 'UserJob', jobTypeId: number, userJobYearTypeId?: number | null }>, latestGithubAnalysisResult?: { __typename?: 'AnalysisResult', analysisResultSkillScores: Array<{ __typename?: 'AnalysisResultSkillScore', skillId: number }> } | null, selfRecommendedSkills: Array<{ __typename?: 'Skill', id: number, name: string }>, characterPersonalities: Array<{ __typename?: 'UserPersonality', id: number, answer: { __typename?: 'PersonalityTag', id: number }, question: { __typename?: 'PersonalityQuestion', id: number } }>, blockCompanies: Array<{ __typename?: 'Company', id: number }>, userSuccessTermAcceptanceHistories: Array<{ __typename?: 'UserSuccessTermAcceptanceHistory', createdAt: string, decision: Types.UserSuccessTermAcceptanceDecision }>, desiredPersonalities: Array<{ __typename?: 'UserPersonality', id: number }>, workHistories: Array<{ __typename?: 'UserWorkHistory', id: number }> } };

export type JobDescriptionDetailV2CurrentUserFragment = { __typename?: 'User', id: number, talentStatus: Types.TalentStatus, profile?: { __typename?: 'UserProfile', age?: number | null, careerMotivation: number, companyName?: string | null, numericAnnualIncome: number, vision?: string | null, latestDevelopmentResults?: string | null, desiredAnnualIncome: { __typename?: 'UserIncome', id: number }, desiredCareerType: { __typename?: 'Career', id: number }, prefecture: { __typename?: 'Prefecture', id: number } } | null, jobs: Array<{ __typename?: 'UserJob', jobTypeId: number, userJobYearTypeId?: number | null }>, latestGithubAnalysisResult?: { __typename?: 'AnalysisResult', analysisResultSkillScores: Array<{ __typename?: 'AnalysisResultSkillScore', skillId: number }> } | null, selfRecommendedSkills: Array<{ __typename?: 'Skill', id: number, name: string }>, characterPersonalities: Array<{ __typename?: 'UserPersonality', id: number, answer: { __typename?: 'PersonalityTag', id: number }, question: { __typename?: 'PersonalityQuestion', id: number } }>, blockCompanies: Array<{ __typename?: 'Company', id: number }>, userSuccessTermAcceptanceHistories: Array<{ __typename?: 'UserSuccessTermAcceptanceHistory', createdAt: string, decision: Types.UserSuccessTermAcceptanceDecision }>, desiredPersonalities: Array<{ __typename?: 'UserPersonality', id: number }>, workHistories: Array<{ __typename?: 'UserWorkHistory', id: number }> };

export const JobDescriptionDetailV2CurrentUserFragmentDoc = gql`
    fragment JobDescriptionDetailV2CurrentUser on User {
  id
  profile {
    age
    careerMotivation
    companyName
    desiredAnnualIncome {
      id
    }
    desiredCareerType {
      id
    }
    numericAnnualIncome
    prefecture {
      id
    }
    vision
    latestDevelopmentResults
  }
  jobs {
    jobTypeId
    userJobYearTypeId
  }
  latestGithubAnalysisResult {
    analysisResultSkillScores {
      skillId
    }
  }
  selfRecommendedSkills {
    id
    name
  }
  characterPersonalities {
    id
    answer {
      id
    }
    question {
      id
    }
  }
  blockCompanies {
    id
  }
  talentStatus
  userSuccessTermAcceptanceHistories {
    createdAt
    decision
  }
  desiredPersonalities {
    id
  }
  workHistories {
    id
  }
}
    `;
export const FetchJobDescriptionDetailV2CurrentUserDocument = gql`
    query FetchJobDescriptionDetailV2CurrentUser {
  currentUser {
    ...JobDescriptionDetailV2CurrentUser
  }
}
    ${JobDescriptionDetailV2CurrentUserFragmentDoc}`;

/**
 * __useFetchJobDescriptionDetailV2CurrentUserQuery__
 *
 * To run a query within a React component, call `useFetchJobDescriptionDetailV2CurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobDescriptionDetailV2CurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobDescriptionDetailV2CurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchJobDescriptionDetailV2CurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>(FetchJobDescriptionDetailV2CurrentUserDocument, options);
      }
export function useFetchJobDescriptionDetailV2CurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>(FetchJobDescriptionDetailV2CurrentUserDocument, options);
        }
export function useFetchJobDescriptionDetailV2CurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>(FetchJobDescriptionDetailV2CurrentUserDocument, options);
        }
export type FetchJobDescriptionDetailV2CurrentUserQueryHookResult = ReturnType<typeof useFetchJobDescriptionDetailV2CurrentUserQuery>;
export type FetchJobDescriptionDetailV2CurrentUserLazyQueryHookResult = ReturnType<typeof useFetchJobDescriptionDetailV2CurrentUserLazyQuery>;
export type FetchJobDescriptionDetailV2CurrentUserSuspenseQueryHookResult = ReturnType<typeof useFetchJobDescriptionDetailV2CurrentUserSuspenseQuery>;
export type FetchJobDescriptionDetailV2CurrentUserQueryResult = Apollo.QueryResult<FetchJobDescriptionDetailV2CurrentUserQuery, FetchJobDescriptionDetailV2CurrentUserQueryVariables>;